import { Box, Button, Typography } from "@mui/material";
import UploadTipGradient from "../../../../components/Vectors/UploadTipGradient";
import SendUploadTipIcon from "../../../../components/Vectors/SendUploadTipIcon";
import SimulateUploadTipIcon from "../../../../components/Vectors/SimulateUploadTipIcon";
import AnaliseUploadTipIcon from "../../../../components/Vectors/AnaliseUploadTipIcon";
import SignUploadTipIcon from "../../../../components/Vectors/SignUploadTipIcon";
import CalendarUploadTipIcon from "../../../../components/Vectors/CalendarUploadTipIcon";
import DelendDrawer from "../../../../components/AppBar/DelendDrawer";
import RightArrow from "../../../../components/Vectors/RightArrow";

const UploadTutorial = ({ openSideBar, setIsTutorialAlreadyVisualized, handleDrawerClose }) => {
  const handleTipsButtonClick = () => {
    localStorage.setItem("viewedTips", true);
    setIsTutorialAlreadyVisualized(true);
  };

  return (
    <DelendDrawer
      title={
        "Antes de tudo, veja como é fácil antecipar as suas Notas Fiscais!"
      }
      subtitle={""}
      open={openSideBar}
      handleCloser={() => {handleDrawerClose(false)}}
    >
      <>
        <UploadTutorialItem
          number={"01"}
          title={"Envie as Notas Fiscais"}
          description={
            "Você importa as Notas Fiscais referentes  as suas vendas."
          }
          icon={<SendUploadTipIcon />}
        />
        <UploadTutorialItem
          number={"02"}
          title={"Simule a antecipação de crédito"}
          description={
            "Selecione a venda que deseja antecipar e faça a sua simulação para gerar uma proposta."
          }
          icon={<SimulateUploadTipIcon />}
        />
        <UploadTutorialItem
          number={"03"}
          title={"Analise a proposta"}
          description={
            "Analise os valores da proposta simulada e decida    se deseja contratar."
          }
          icon={<AnaliseUploadTipIcon />}
        />
        <UploadTutorialItem
          number={"04"}
          title={"Assine o contrato"}
          description={
            "Você assina o contrato de antecipação. Toda a transação é realizada de forma rápida e segura."
          }
          icon={<SignUploadTipIcon />}
        />
        <UploadTutorialItem
          number={"05"}
          title={"Receba o dinheiro na sua conta"}
          description={
            "No dia combinado você recebe o pagamento em  sua conta bancária pela venda dos seus recebíveis."
          }
          icon={<CalendarUploadTipIcon />}
        />
      </>
      <Button
        type="submit"
        onClick={handleTipsButtonClick}
        variant="contained"
        sx={{
          textTransform: "capitalize",
          borderRadius: 50,
          marginTop: "32px",
          textUnderlineOffset: "10px",
          "&.Mui-disabled": {
            opacity: 1,
            color: "#BCBCBC",
            backgroundColor: "#E7E7E7",
          },
        }}
        fullWidth
        endIcon={<RightArrow />}
      >
        Iniciar
      </Button>
    </DelendDrawer>
  );
};

const UploadTutorialItem = ({ number, title, description, icon }) => {
  return (
    <Box
      sx={{
        borderRadius: "0px 10px 10px 0px",
        border: "1px solid #D9D9D9",
        background: "#FFF",
        display: "flex",
        flexDirection: "row",
        m: 2,
      }}
    >
      <Box>
        <UploadTipGradient number={number} />
      </Box>

      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          paddingLeft: "12px",
          paddingRight: "12px",
          paddingTop: "10px",
          width: "30vw",
        }}
      >
        <Typography
          style={{
            color: "#00010C",
            fontFamily: "Poppins",
            fontSize: "18px",
            fontStyle: "normal",
            fontWeight: "600",
            lineHeight: "26px",
            marginTop: 8,
          }}
        >
          {title}
        </Typography>
        <Typography
          style={{
            color: "#5E708A",
            fontFamily: "Poppins",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: "400",
            lineHeight: "21px",
            marginTop: 6,
          }}
        >
          {description}
        </Typography>
      </Box>
      <Box
        style={{ textAlign: "center", paddingTop: "28px", paddingLeft: "8px" }}
      >
        {icon}
      </Box>
    </Box>
  );
};

export default UploadTutorial;
